import { useState } from 'react'
import { Rv }             from '../../components'
import { STAGES }         from '../../constants/data'
import { PipelineScene }  from './PipelineScene'

export function PipelineSection() {
  const [active, setActive] = useState(-1)
  const [done,   setDone]   = useState(false)
  const onProgress = (idx, isDone) => {
    setActive(idx)
    if (isDone) { setDone(true); setTimeout(() => setDone(false), 1200) }
  }
  return (
    <section id="pipeline" className="sec" style={{ paddingTop: '4.5rem', paddingBottom: '4.5rem' }}>
      <div className="wrap">
        <Rv className="sh">
          <div className="slb">Live Verification</div>
          <h2 className="st">Every Release Runs<br/>the Full Gauntlet</h2>
          <div className="gbar"/>
          <p className="ss">A simulated pipeline — the same checks every build goes through before it ships, looping live.</p>
        </Rv>
        <Rv className="gls pipeline-card" delay={0.15}>
          <div className="pipeline-canvas-wrap"><PipelineScene onProgress={onProgress}/></div>
          <div className="pipeline-stages">
            {STAGES.map((s, i) => (
              <div key={s} className={`pstage${i < active ? ' pass' : ''}${i === active ? ' run' : ''}`}>
                <span className="pdot"/><span>{s}</span>
              </div>
            ))}
          </div>
          {done && <div className="pipeline-done">✓ All checks passed — build shipped</div>}
        </Rv>
      </div>
    </section>
  )
}
